import app from '../../admin/app';
import DashboardWidget from './DashboardWidget';
import isExtensionEnabled from '../utils/isExtensionEnabled';
import getCategorizedExtensions from '../utils/getCategorizedExtensions';
import Link from '../../common/components/Link';
import classList from '../../common/utils/classList';
import Icon from '../../common/components/Icon';
export default class ExtensionsWidget extends DashboardWidget {
  oninit(vnode) {
    super.oninit(vnode);
    this.categorizedExtensions = getCategorizedExtensions();
  }
  className() {
    return 'ExtensionsWidget';
  }
  content() {
    const categories = app.extensionCategories;
    return m("div", {
      className: "ExtensionsWidget-list"
    }, Object.keys(categories).map(category => !!this.categorizedExtensions[category] && this.extensionCategory(category)));
  }
  extensionCategory(category) {
    return m("div", {
      className: "ExtensionList-Category"
    }, m("h4", {
      className: "ExtensionList-Label"
    }, app.translator.trans("core.admin.nav.categories.".concat(category))), m("ul", {
      className: "ExtensionList"
    }, this.categorizedExtensions[category].map(extension => this.extensionWidget(extension))));
  }
  extensionWidget(extension) {
    const isAbandoned = extension.abandoned;
    const hasReplacement = typeof isAbandoned === 'string';
    return m("li", {
      className: classList('ExtensionListItem', {
        disabled: !isExtensionEnabled(extension.id),
        abandoned: isAbandoned
      })
    }, m(Link, {
      href: app.route('extension', {
        id: extension.id
      })
    }, m("div", {
      className: "ExtensionListItem-content"
    }, m("div", {
      className: "ExtensionListItem-icon-wrapper"
    }, m("span", {
      className: "ExtensionListItem-icon ExtensionIcon",
      style: extension.icon
    }, !!extension.icon && m(Icon, {
      name: extension.icon.name
    })), isAbandoned && m("span", {
      className: classList('ExtensionListItem-badge Badge', hasReplacement ? 'Badge--danger' : 'Badge--warning')
    }, m(Icon, {
      name: "fas fa-exclamation-triangle"
    }))), m("span", {
      className: "ExtensionListItem-title"
    }, extension.extra['flarum-extension'].title))));
  }
}
flarum.reg.add('core', 'admin/components/ExtensionsWidget', ExtensionsWidget);